export default {
  placeholder: 'Wybierz tag',
};
